export const TextEffects3dViewerType = 'wixui.TextEffects3d' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffects3d-container',
    text: 'TextEffects3d-text',
  },
} as const;
